import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FCMMessageRegistration } from 'src/app/Model/Common/FCMMessageRegistration';
import { RiderLocation } from 'src/app/Model/Common/RiderLocation';
import { APIFactoryEndPoints } from 'src/app/Model/Common/apifactory-end-points';
import { RiderDetails } from 'src/app/Model/Rider/rider-details';

@Injectable({
  providedIn: 'root'
})
export class RiderService {

  constructor(
    private http: HttpClient,
    private apiFactory: APIFactoryEndPoints,
  ) { }

  saveFCMRegistrationData(url: string, formData: FCMMessageRegistration) {
    return this.http.post(
      url,
      formData

    );
  }

  getRiderByEmail(email: string) {
    return this.http.get<any>(this.apiFactory.getRiderByEmail + "/" + email);
  }

  insertRider(url: string, obj: UntypedFormGroup, aadhaarImage: File, aadhaarBackImage: File, riderSelfie: File, riderDl: File) {
    let formData = new FormData();
    formData.append('formData', new Blob([JSON.stringify(obj.value)], { type: 'application/json' }));
    formData.append('aadhaarImage', aadhaarImage);
    formData.append('aadhaarBackImage', aadhaarBackImage);
    formData.append('riderSelfie', riderSelfie);
    formData.append('riderDl', riderDl);

    return this.http.post<RiderDetails>(url, formData);
  }

  updateStatus(url: string, email: string, checked: boolean) {
    return this.http.get<any>(url + '/' + email + '/' + checked);
  }

  getImage(url: string, img: String): any {
    return this.http.get<any>(url + '/' + img, { responseType: 'arraybuffer' as 'json' })
  }

  updateRiderPosition(url: string, riderLocation: RiderLocation) {
    console.log("Received LongLat Save===" + riderLocation.email + "===" + riderLocation.longitude + "===" + riderLocation.latitude)
    return this.http.post(url, riderLocation);
  }

  signOutRider(url: string, token: string) {
    return this.http.get<any>(url + '/' + token );
  }
}
